goog.provide('el8.service.tz');


/**
 * Module to support timezone/locale sensitivity
 *
 * There should be NO use of the new Date() constructor in the client-code.
 *
 * Notes on limitations:
 *   1. The String formatting functions (from resources/date.js) that the client
 * currently uses are not aware of this file, so they will use the timezone that was
 * attached to the tzDate when it was created, not necessarily the timezone currently
 * set in this file. Fixing this requires replacing all references to asStringFormat
 * (which comes from date.js) with toString (which comes from timezone.date.js) and
 * updating the Format strings that get fed into toString. We deemed this an acceptable
 * compromise because we do not anticipate / want the practiceLocale changing without
 * a page refresh.
 *
 *   2. Any dates created before el8.service.tz.init() is called will not be timezone
 * aware, because the Olson tz data will not have been loaded. We deemed this ok, because
 * it should only apply to the default dates set in models, which should:
 * A. be dates, not times and B. should not be relied on in any case.
 *
 *   3. timezoneJS behaves well if it's given no practiceLocale but poorly if it's given a
 * null value, so always check if practiceLocale is set and fallback intelligently if
 * not when you are making a call into the module
 */

el8.service.tz = (function() {

    var practiceLocale = null;

    return {

        /**
         * Initialize module with current locale
         */
        init: function() {
            timezoneJS.timezone.loadingScheme = timezoneJS.timezone.loadingSchemes.MANUAL_LOAD;
            timezoneJS.timezone.loadZoneDataFromObject(tzdata)
            practiceLocale = el8Globals['PRACTICE_LOCALE'];  // e.g. 'America/Los_Angeles'

            if (!tzdata.zones[practiceLocale]) {
                // short circuit, this isn't a valid timezone!
                practiceLocale = null;
                UIM && UIM.logError('Practice ' + el8Globals.PRACTICE_ID + ' has an invalid timezone ('+
                    el8Globals.PRACTICE_LOCALE + ')!');
            }
        },

        checkLocalIsPractice: function(practiceNowStr) {
            // We add this so we can show an appropriate alert if user's local
            // time isn't same as practice time
            //
            // Assumes that practiceNowStr is close enough to now() that we can compare
            // practiceNowStr's offset with the client's now()'s offset and determine if we
            // are in the same timezone or not
            var strs = practiceNowStr.split(' ');
            if (strs.length > 2) {
                var practiceOffset = strs[2]/100;
                return practiceOffset === this.getLocalTzOffset();
            }
            return true; // don't rock the boat if /status/ returning misformed times
        },

        getPracticeTzOffset: function(_date) {
            if (practiceLocale) {
                var dateToCheck = _date ? new timezoneJS.Date(_date, practiceLocale) : new timezoneJS.Date(practiceLocale);
                return -1*dateToCheck.getTimezoneOffset()/60;
            }
            return this.getLocalTzOffset(_date);
        },

        getLocalTzOffset: function(_date) {
            var dateToCheck = _date ? new Date(_date) : new Date();
            return -1*dateToCheck.getTimezoneOffset()/60;
        },

        _setPracticeLocale: function(_practiceLocale) {
            // This is mostly for testing convenience. In the app, it would be bad
            // for practice locale to change after page init (because dates on the
            // page would have mixed timezones)
            practiceLocale = _practiceLocale;
        },

        /**
         * Managing conversion of dates from the server. This is the function to
         * use when you actually when to timezone shift a datetime.
         */
        toTzDateTime: function(strDate) {
            /**
             * Expect str in format (from server will be PST, so -0700 or -0800)
             *    09/06/2009 15:09:44 -0700
             */
            if (practiceLocale) {
                return new timezoneJS.Date(strDate, practiceLocale);
            } else {
                return new timezoneJS.Date(strDate);
            }
        },

        toTzDate: function(strDate) {
            // TODO In the future, we want to make it so that a tzDate is
            // distinguishable with certainty from a tzDateTime so we don't
            // have to remember
            //
            // We don't need to do any time-shifting for toTzDate, but newTzDate
            // takes care of attaching the practice locale to this date
            return this.newTzDate(strDate);
        },

        toTzTime: function(strTime) {
            // Expect strTime to be in 24-hour format: HH:MM (zeropadded hours)
            var time = this.newTzTime();
            var strs = strTime.split(':');
            var hours = strs[0]*1;
            var mins = strs[1]*1;
            time.setHours(hours);
            time.setMinutes(mins);
            return time;
        },

        /**
         * Convenience methods for use by soy templates; take formatted client
         * strings (assumed to be tz=practiceLocale)
         */
        soyStr: function(_date) {
            if (!_date) { return ''; }
            return this.asServerFormatDateTime(_date); // returns null if _date is invalid
        },

        _soyHelper: function(str, formatFn, err) {
            try {
                if (str === '') { return ''; }
                if (str === null) { throw new Error(); }
                if (str.match('NaN')) { throw new Error(); }

                return formatFn.call(this, str);

            } catch(ex) {
                var msg = 'invalid date into soy';
                if (ex.stack) { msg += '\n\n' + ex.stack; }
                UIM && UIM.logError(msg);
                return err || 'Invalid Date';
            }
        },

        soyDateTime: function(str) {
            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asDateTimeString();
            });
        },

        soyDate: function(str) {
            // if we think this is already formatted str, then just pass it thru
            if (str && str.match(/^((\d{1,2})\/){2}(\d{4})$/g)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asString();
            });
        },

        soyShortDate: function(str) {

            // if we think this is already formatted str, then just pass it thru
            if (str && str.match(/^(\d{1,2})\/(\d{4})$/g)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asShortString();
            });
        },

        soyFullDate: function(str) {
            // if we think this is already formatted str, then just pass it thru
            if (str && (/^(\w{3}), (\w{3}) (\d{1,2}), (\d{4})$/g).test(str)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asFullString();
            });
        },

        soyTime: function(str) {

            // if we think this is a client-formatted str, then just pass it thru
            // ASSUMES: time formatting on client includes am/pm
            if (str && str.toLowerCase().match(/[ap]m/g)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asTimeString();
            }, 'Invalid Time');
        },

        soyMonthDay: function(str) {

            // if we think this is already formatted str, then just pass it thru
            if (str && (/^(\w{3}) (\d{1,2})$/g).test(str)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asMonthDayString();
            });
        },

        soyLongMonthDay: function(str) {

            // if we think this is already formatted str, then just pass it thru
            if (str && (/^(\w+) (\d{1,2})$/g).test(str)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asLongMonthDayString();
            });
        },

        soyMonth: function(str) {

            // if we think this is already formatted str, then just pass it thru
            if (str && (/^(\w{3})$/g).test(str)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asMonthString();
            });
        },

        soyDay: function(str) {

            // if we think this is already formatted str, then just pass it thru
            if (str && (/^(\d{1,2})$/g).test(str)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asDayString();
            });
        },

        soyYear: function(str) {

            // If number is being passed in, assume its already formatted
            if (str && !isNaN(str*1)) { return str; }

            var that = this;
            return this._soyHelper(str, function(_str) {
                return that.toTzDateTime(_str).asYearString();
            });
        },

        /**
         * Use this function to create datetime objects based on the primary practice locale.
         */
        newPrimaryPracticeTzDateTime: function(
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
            primaryPracticeLocale
        ) {
            return new timezoneJS.Date(
                year,
                month,
                day,
                hours,
                minutes,
                seconds,
                primaryPracticeLocale
            )
        },

        /**
         * Use this function to create datetime objects based on client-data. Because
         * dates and times on the client should already be based on the practice's tz,
         * this function assumes that '08/28/1958 1:00am' is intended to mean 1am in
         * the practice's tz and simply adjusts the tz on object being sent to the server
         * to reflect that fact (which matters if the client's machine is not actually in
         * the practice's tz).
         *
         * If you want to take a datetime that is not already in the practice's tz and convert
         * it, use toTzDateTime instead.
         */
        newTzDateTime: function(var_args) {
            switch(arguments.length) {
                case 0:
                    // This is supposed to be "now"
                    if (practiceLocale) {
                        return new timezoneJS.Date(practiceLocale);
                    } else {
                        return new timezoneJS.Date();
                    }
                    break;
                // If we have a datetime from the client, assume that it was created in practice time
                // and doesn't need to be shifted again. All we want to do is put the correct timezone
                // on the object for the server's sake.
                case 1:
                    if (practiceLocale) {
                        var dateConstructorArg = arguments[0];
                        if (typeof arguments[0] === 'string' || typeof arguments[0] === 'number') {
                            // We don't want to timeshift the strings/utimes provided to this function so we're
                            // going to construct a regular Date and pull components out of it below
                            dateConstructorArg = new Date(arguments[0]);
                        }

                        if (!this._validateDate(dateConstructorArg)) {
                            // This maintains backwards compatibility with Date:
                            //  1. for null input, return the zero-date (unix time)
                            //  2. for other invalid input, return an invalid Date object (not null)
                            if (dateConstructorArg === null) { return new timezoneJS.Date(0); }
                            return new timezoneJS.Date('Invalid Date');
                        }

                        // this constructor should not time-shift its input - it just attaches the right timezone
                        return new timezoneJS.Date(
                            dateConstructorArg.getFullYear(),
                            dateConstructorArg.getMonth(),
                            dateConstructorArg.getDate(),
                            dateConstructorArg.getHours(),
                            dateConstructorArg.getMinutes(),
                            dateConstructorArg.getSeconds(),
                            dateConstructorArg.getMilliseconds(),
                            practiceLocale
                        );
                    } else {
                        return new timezoneJS.Date(arguments[0]);
                    }
                    break;
                default:
                    if (practiceLocale) {
                        return new timezoneJS.Date(
                            arguments[0],
                            arguments[1],
                            arguments[2] || 0,
                            arguments[3] || 0,
                            arguments[4] || 0,
                            arguments[5] || 0,
                            arguments[6] || 0,
                            practiceLocale);
                    } else {
                        return new timezoneJS.Date(
                            arguments[0],
                            arguments[1],
                            arguments[2] || 0,
                            arguments[3] || 0,
                            arguments[4] || 0,
                            arguments[5] || 0,
                            arguments[6] || 0);
                    }
            }
        },

        newTzDate: function(var_args) {
            return this.newTzDateTime.apply(this, arguments).zeroTime();
        },

        newTzTime: function(hours, minutes, seconds, milliseconds) {
            if (hours instanceof Date || hours instanceof timezoneJS.Date) {
                var dt = this.newTzDateTime(hours);
                dt.setFullYear(1900);
                dt.setMonth(0);
                dt.setDate(0);
                // For some reason this leaves us with a date of 12/31/1899, but that's what
                // newTzDateTime does below too, so it's our standard
                return dt;
            }
            return this.newTzDateTime(0, 0, 0, hours || 0, minutes || 0, seconds || 0, milliseconds || 0);
        },

        /**
         * Other files should generally avoid calling new Date() directly. Sometimes,
         * we want to know what time it is for the user in the physical world, rather
         * than for the practice; when that happens, we want an explicitly named function. */
        computerLocalNow: function() { return new Date(); },

        now: function() { return this.newTzDateTime(); },
        nowPlusHours: function(hours) {
            var t = this.now();
            t.setHours(t.getHours() + hours);
            return t;
        },
        today: function() { return this.newTzDate(); },
        todayPlusDays: function(days) {
            var today = this.today();
            return this.newTzDate(today.getFullYear(),
                                  today.getMonth(),
                                  today.getDate() + days);
        },
        yesterday: function() {
            return this.todayPlusDays(-1);
        },

        /**
         * Managing stringifying of dates for the server
         *
         * Note: these currently use the timezone offset tied to the date object itself
         * (i.e., the timezone when the dt was created). If we change our date formatting
         * functions to rely on the currently set practiceLocale in this file,
         * _date.getTimezoneOffset() should be based off this.getPracticeTzOffset()
         */
        asServerFormatDateTime: function(_date) {
            if (!this._validateDate(_date)) { return null; }
            // There are datetimes where the timezone isn't necessarily a clean hour
            // difference (e.g. HI prior to 06/08/1947 2AM had a 2.5 hour difference long
            // ago). We need to factor that in when converting the datetime to string
            var tzOffset = _date.getTimezoneOffset();
            var tzStr = this._zeroPad(Math.abs(Math.floor(tzOffset / 60))) + this._zeroPad(Math.abs(tzOffset % 60).toString());
            if (_date.getTimezoneOffset() > 0) {
                tzStr = '-' + tzStr;
            } else {
                tzStr = '+' + tzStr;
            }
            // Eventually should sync this up with settings.SERVER_JSON_DATETIME_FMT
            // and provide support in date.js for tz formatting
            return _date.asStringFormat(Date.serverDateTimeFormat) + ' ' + tzStr;
        },

        asServerFormatDate: function(_date) {
            if (!this._validateDate(_date)) { return null; }
            return _date.asStringFormat(Date.serverDateFormat);
        },

        asServerFormatTime: function(_date) {
            if (!this._validateDate(_date)) { return null; }
            return _date.asStringFormat(Date.serverTimeFormat);
        },

        asUrlFormatDate: function(_date) {
            return encodeURIComponent(this.asServerFormatDate(_date));
        },

        /**
         * Make strings for unique identification of dates and datetimes
         */
        asDateTimeStr: function(_date) {
            return _date.asDateStr() + '_' + _date.asTimeStr();
        },

        asDateStr: function(_date) {
            return _date.asStringFormat('mmddyyyy');
        },

        asTimeStr: function(_date) {
            return _date.asStringFormat('HHMM');
        },

        /**
         * HELPERS
         */
        noonTimeIfNotToday: function(_date) {
            var today = this.today();
            // If _date is NOT today
            if (today.getFullYear() !== _date.getFullYear() ||
                    today.getMonth() !== _date.getMonth() ||
                    today.getDate() !== _date.getDate()) {
                _date.zeroTime();
                _date.setHours(12);
            } else {
                var now = this.now();
                _date.setMilliseconds(now.getMilliseconds());
                _date.setSeconds(now.getSeconds());
                _date.setMinutes(now.getMinutes());
                _date.setHours(now.getHours());
            }
            return _date;
        },

         zeroTimeIfNotToday: function(_date) {
            var today = this.today();
            // If _date is NOT today
            if (today.getFullYear() !== _date.getFullYear() ||
                    today.getMonth() !== _date.getMonth() ||
                    today.getDate() !== _date.getDate()) {
                _date.zeroTime();
            } else {
                var now = this.now();
                _date.setMilliseconds(now.getMilliseconds());
                _date.setSeconds(now.getSeconds());
                _date.setMinutes(now.getMinutes());
                _date.setHours(now.getHours());
            }
            return _date;
        },

       processTimeInput: function(str) {
            var t = this.newTzTime();
            var time = str.match(/(\d{1,2})(?:[:., ]?(\d\d))?\s*([pP]?)/);
            if (time) {
                t.setHours(parseInt(time[1], 10) +
                        ((parseInt(time[1], 10) < 12 && time[3]) ? 12 : 0) -
                        ((parseInt(time[1], 10) === 12 && !time[3]) ? 12 : 0));
                t.setMinutes(parseInt(time[2], 10) || 0);
                return t;
            } else {
                return null;
            }
        },

        processDateAndTimeInputs: function(dateStr, timeStr) {
            var dateTime = this.newTzDateTime(dateStr);
            var time = this.processTimeInput(timeStr);
            if (!this._validateDate(dateTime) || !this._validateDate(time)) {
                return null;
            }

            dateTime.setHours(time.getHours());
            dateTime.setMinutes(time.getMinutes());
            dateTime.setSeconds(time.getSeconds());

            return dateTime;
        },

        _zeroPad: function(num) {
            var s = '0'+num;
            return s.substring(s.length-2);
        },

        _validateDate: function(_date) {
            if ( !_date || !_date.getTime || isNaN(_date.getTime()) ) {
                return false;
            }
            return true;
        }

    };

})();
